import { Routes, Route } from "react-router-dom";

import HomeCare from "../homecare/homeCarePage";
import Cities from "../../shared/components/cities/Cities";

export default function HomeCareRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeCare />} />
      <Route path="/city/:id" element={<Cities />} />
      <Route path="/city/:id/active" element={<Cities />} />
    </Routes>
  );
}
